(ns app.strive-forms.defaults)

(def default-values
  {:boolean-true-value "1"
   :boolean-false-value "0"
   :boolean-true-letter "y"
   :boolean-false-letter "n"
   :back_tooltip "Back"
   :next_tooltip "Next"
   :step_text "Step"
   :required_text "Required"
   :email_input_label "EMAIL ADDRESS"
   :number_input_label "Number"
   :multi_select_other_input_label "Other"
   :submit_button_text "Submit"
   :continue_button_text "Continue"
   :powered_by "Powered by"
   :other-label "Other"
   :scroll-down-condition 0.4
   :scroll-down-pixels 300
   :opinion_scale {:na_text "N/A"
                   :na_value "-1"}
   :errors {:email {:invalid "This is not a valid email"
                    :verification "Email verification failed, please try again"}
            :number {:min-limit "Input must be greater than %s"
                     :max-limit "Input must be smaller than %s"
                     :min-max-limit "Input must be between %s and %s"
                     :number-invalid "Input must be a number"}
            :multi_select {:range-invalid "You need to select from %s to %s items!"}}
   :gaps-primary {:page-start-to-languages "60px"
                  :page-title-to-languages "15px"
                  :languages-to-header-gap "60px"
                  :icon-to-steps-gield-gap "5px"
                  :page-title-to-questions-in-multi "5px"
                  :header-to-question-question-card "25px"
                  :question-desc-to-question-input "2px"
                  :error-message-to-action-button "18px"
                  :between-questions-gap "10px"}
   :gaps-mobile-view {:page-start-to-languages "52px"
                      :page-title-to-languages "15px"
                      :languages-to-header-gap "60px"
                      :icon-to-steps-gield-gap "5px"
                      :page-title-to-questions-in-multi "5px"
                      :header-to-question-question-card "10px"
                      :question-desc-to-question-input "10px"
                      :error-message-to-action-button "5px"
                      :between-questions-gap "30px"}
   :themes {:primary "#7B4CFF"
            :error "#FF2157"
            :error-mesage "#ED2153"
            :dark-gray "#9C9EA8"
            :light-gray "rgba(0, 0, 0, 0.87)"}
   :title {:font-size "40"
           :font-family "'Petrona', serif"
           :align "center"
           :color "#58515e"
           :width "736px"
           :align-in-multi "left"
           :align-in-multi-rtl "right"
           :fraction-of-title 0.55
           :width-in-multi "100%"}
   :page-title {:font-size "40"
                :font-family "'Petrona', serif"
                :align "center"
                :color "#58515e"
                :width "736px"
                :align-in-multi "left"
                :fraction-of-title 0.8
                :width-in-multi "100%"}
   :width-for-mobile-view "766px"
   :width-for-mobile-galaxy-fold-view "300px"
   :width-for-other-text-field "330px"
   :nps-indicator-color {:detractor "#EC294F"
                         :passive "#FFD837"
                         :promoter "#52B1A9"}})